/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchFacetsReset = {
    /**
     * Reset all facets
     */
    resetAllFacets() {
        this.selectedFacets = []

        if (this.hasSeoIndexedFilters) {
            // Reload the page if SEO indexed filters are used
            this.seoIndexedFilterPageReload()
            return
        }

        this.setUrlPageParam(1)
        this.resetProducts()
        this.getProducts('facets')
        this.$dispatch('facets-changed', null)
    },
    /**
     * Reset facets for the given attribute
     *
     * @param {string} attribute
     */
    resetSelectedFacets(attribute) {
        if (attribute !== this.facetConfig.mergedBhAttribute) {
            this.selectedFacets = this.selectedFacets
                .filter(facet => facet.attribute !== attribute && !facet.attribute.includes(attribute))
        } else {
            // find every facet from this.facetConfig.bhAttributes in selectedFacets and remove it
            this.selectedFacets = this.selectedFacets
                .filter(facet => !this.facetConfig.bhAttributes.includes(facet.attribute))
        }

        if (this.hasSeoIndexedFilters) {
            // Reload the page if SEO indexed filters are used
            this.seoIndexedFilterPageReload()
            return
        }

        this.setUrlPageParam(1)
        this.resetProducts()
        this.getProducts('facets')
        this.$dispatch('facets-changed', attribute)
    }
}

export default liveSearchFacetsReset
